(function () {
  'use strict';

  if (window._ddAuthStateInit) return;
  window._ddAuthStateInit = true;

  var cfg = window.__DD_AUTH || {};
  var root = document.documentElement;
  var serverIsCustomer = !!cfg.serverIsCustomer;
  var loginUrl = String(cfg.accountLoginUrl || '/account/login');
  var logoutUrl = String(cfg.accountLogoutUrl || '/account/logout');
  var TRANSITION_KEY = 'dd-auth-transition';

  function setAuthAttr(isCustomer) {
    root.setAttribute('data-glass-customer', isCustomer ? 'true' : 'false');
  }

  function currentAttrIsCustomer() {
    return root.getAttribute('data-glass-customer') === 'true';
  }

  function samePath(a, b) {
    try {
      var ua = new URL(a, window.location.origin);
      var ub = new URL(b, window.location.origin);
      return ua.pathname.replace(/\/+$/, '') === ub.pathname.replace(/\/+$/, '');
    } catch (e) {
      return String(a || '').replace(/\/+$/, '') === String(b || '').replace(/\/+$/, '');
    }
  }

  async function probeCustomer() {
    var res = await fetch('/account', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store'
    });
    return res.url.indexOf(loginUrl) === -1;
  }

  /* Suppress the destructive reload path when a modal dialog is
     visible. Reloading the page while the user is mid-review,
     mid-checkout, or mid-anything-else inside a dialog destroys
     their in-progress work — the auth state sync can wait until
     they close the dialog. The dd-reviews write modal sets
     `[role="dialog"][aria-modal="true"]`, and the sitewide modal
     contract follows the same a11y pattern, so this single
     selector catches every case where a reload would be
     destructive without enumerating each modal.

     Concrete user-reported failure this prevents:
       1. User opens write-review modal on a PDP.
       2. User taps "Add photos" → iOS hands off to the system
          photo picker (long-running system view).
       3. Safari restores the tab from bfcache when the user
          picks a photo (`pageshow` with `event.persisted === true`).
       4. probeCustomer() does `fetch('/account')` which can
          redirect to /account/login on a flaky cookie-sync
          (mobile network blip, long picker session) — even
          though the customer is genuinely still logged in.
       5. WITHOUT this guard: `window.location.replace()` reloads
          the page, the modal is destroyed, the review draft is
          lost. Reads to the user as "the page reloaded when I
          tried to attach a photo."
       6. WITH this guard: the DOM attribute is updated and an
          event is dispatched for passive listeners. Modal stays
          open. If the customer really did log out in another
          tab, the next user-initiated navigation will reload
          into a guest experience. */
  function hasOpenDialog() {
    return !!document.querySelector('[role="dialog"][aria-modal="true"]');
  }

  async function revalidateAuth(opts) {
    opts = opts || {};
    try {
      var isCustomer = await probeCustomer();
      var attrCustomer = currentAttrIsCustomer();

      if (isCustomer !== attrCustomer) {
        if (hasOpenDialog()) {
          /* Soft-update path: keep the user's dialog state intact.
             Update the DOM attribute so glass-nav / account chrome
             can react via the existing CSS selectors that read it,
             and dispatch a custom event so JS listeners can do
             targeted re-renders without a page reload. */
          setAuthAttr(isCustomer);
          if (opts.clearTransition) {
            try { sessionStorage.removeItem(TRANSITION_KEY); } catch (e) {}
          }
          try {
            document.dispatchEvent(new CustomEvent('dd:auth:state-changed', {
              detail: { isCustomer: isCustomer, deferredReload: true },
            }));
          } catch (e) { /* noop — event dispatch is best-effort */ }
          return;
        }
        var current = window.location.pathname + window.location.search + window.location.hash;
        window.location.replace(current || '/');
        return;
      }

      setAuthAttr(isCustomer);
      if (opts.clearTransition) {
        try { sessionStorage.removeItem(TRANSITION_KEY); } catch (e) {}
      }
    } catch (e) {
      /* Keep server-rendered state when probe fails. */
    }
  }

  function markTransition(type) {
    try { sessionStorage.setItem(TRANSITION_KEY, String(type || 'unknown')); } catch (e) {}
  }

  setAuthAttr(serverIsCustomer);

  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted) revalidateAuth({ clearTransition: true });
  });

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href) return;
      if (samePath(href, logoutUrl) || samePath(href, '/account/logout')) {
        markTransition('logout');
      }
    },
    true
  );

  document.addEventListener('dd:auth:transition', function (e) {
    markTransition(e && e.detail && e.detail.type ? e.detail.type : 'custom');
  });

  try {
    var pending = sessionStorage.getItem(TRANSITION_KEY);
    if (pending) {
      revalidateAuth({ clearTransition: true });
    }
  } catch (e) {}

  window.ddAuthState = {
    markTransition: markTransition,
    revalidate: revalidateAuth
  };
})();
